<ui-icon [name]="icon" [size]="iconSize" [flip]="flip"></ui-icon>
<ng-content></ng-content>
